/**
 * 格式化日期
 * @param date 日期
 * @param format 格式化字符串
 */
export const toDateString = (date: Date, format = 'yyyy-MM-ddThh:mm:ss') => {
  const original = [
    { key: 'M+', value: date.getMonth() + 1 },
    { key: 'd+', value: date.getDate() },
    { key: 'h+', value: date.getHours() },
    { key: 'm+', value: date.getMinutes() },
    { key: 's+', value: date.getSeconds() },
    { key: 'q+', value: Math.floor((date.getMonth() + 3) / 3) }, //季度
    { key: 'S', value: date.getMilliseconds() } //毫秒
  ]

  const dic = original.map(a => ({
    ...a,
    value: a.value.toString()
  }))

  // year
  const year = format.match(/(y+)/)
    ? format.replace(
        RegExp.$1,
        date
          .getFullYear()
          .toString()
          .substr(4 - RegExp.$1.length)
      )
    : format

  return dic.reduce(
    (pre, { key, value }) =>
      pre.match(new RegExp(`(${key})`))
        ? pre.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? value
              : '00'.concat(value).substr(value.length)
          )
        : pre,
    year
  )
}

export const createDateFormatter = (format: string) => (date: Date | string) =>
  toDateString(new Date(date), format)

// typo fixure
export const toDataString = toDateString
